import { getFirestore, doc, setDoc, getDoc, deleteDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { GoodThing } from '../types/good-things';
import { dataApp } from '../config/firebase';

interface FavoriteGoodThing extends GoodThing {
  favoritedAt: string;
}

class FavoritesService {
  private db = getFirestore(dataApp);

  async addToFavorites(userEmail: string, goodThing: GoodThing): Promise<void> {
    const favoriteRef = doc(this.db, 'favorites', `${userEmail}_${goodThing.id}`);
    // Create a new object with only the required fields and non-undefined optional fields
    const favorite: FavoriteGoodThing = {
      id: goodThing.id,
      date: goodThing.date,
      submitter: goodThing.submitter,
      recipients: goodThing.recipients,
      category: goodThing.category,
      note: goodThing.note,
      favoritedAt: new Date().toISOString(),
      // Only include optional fields if they are defined
      ...(goodThing.status !== undefined && { status: goodThing.status }),
      ...(goodThing.timestamp !== undefined && { timestamp: goodThing.timestamp })
    };
    await setDoc(favoriteRef, favorite);
  }

  async removeFromFavorites(userEmail: string, goodThingId: string): Promise<void> {
    const favoriteRef = doc(this.db, 'favorites', `${userEmail}_${goodThingId}`);
    await deleteDoc(favoriteRef);
  }

  async getFavorites(userEmail: string): Promise<FavoriteGoodThing[]> {
    const favoritesRef = collection(this.db, 'favorites');
    const q = query(favoritesRef, where('__name__', '>=', `${userEmail}_`), where('__name__', '<', `${userEmail}_\uf8ff`));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => doc.data() as FavoriteGoodThing);
  }

  async isFavorite(userEmail: string, goodThingId: string): Promise<boolean> {
    const favoriteRef = doc(this.db, 'favorites', `${userEmail}_${goodThingId}`);
    const docSnap = await getDoc(favoriteRef);
    return docSnap.exists();
  }
}

export const favoritesService = new FavoritesService();
